import { useMutation, useQueryClient } from '@tanstack/react-query';
import API from 'api/API';
import { QueryKeys } from 'api/models/QueryKeys';

export const useCreateDelivery = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (...args: Parameters<typeof API.deliveries.createDelivery>) =>
      API.deliveries.createDelivery(...args),
    onSuccess: async () =>
      Promise.all([
        // invalidate the affected data sources
        queryClient.invalidateQueries([QueryKeys.Deliveries]),
        queryClient.invalidateQueries([QueryKeys.Order]),
      ]),
    meta: {
      ignoreGlobalError: true,
    },
  });
};
